import {
  Wind, Fan, Zap, Flame, ChefHat, Utensils, CookingPot,
  Beef, Coffee, Soup, Refrigerator, Microwave,
  Package, Boxes, ShoppingBag, ShoppingCart,
  Wrench, Hammer, Cog, Settings, Plug, PlugZap,
  Lightbulb, Power, Cable, Snowflake, ThermometerSun,
  Home, House, Bath, ShowerHead, Tag, Star, Sparkles, LayoutGrid,
} from 'lucide-react';

/* Closed registry: only the icons selectable in Admin > Categorias (keeps lucide tree-shakeable). */
export const CATEGORY_ICONS = {
  Wind, Fan, Zap, Flame, ChefHat, Utensils, CookingPot,
  Beef, Coffee, Soup, Refrigerator, Microwave,
  Package, Boxes, ShoppingBag, ShoppingCart,
  Wrench, Hammer, Cog, Settings, Plug, PlugZap,
  Lightbulb, Power, Cable, Snowflake, ThermometerSun,
  Home, House, Bath, ShowerHead, Tag, Star, Sparkles, LayoutGrid,
};

export const CATEGORY_ICON_NAMES = Object.keys(CATEGORY_ICONS);
